'use strict';

// https://github.com/tc39/proposal-iterator-helpers
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var anObject = require('../internals/an-object');
var getIteratorDirect = require('../internals/get-iterator-direct');
var createAsyncIteratorProxy = require('../internals/async-iterator-create-proxy');
var closeAsyncIteration = require('../internals/async-iterator-close');
var AsyncIteratorProxy = createAsyncIteratorProxy(function (Promise) {
  var state = this;
  var iterator = state.iterator;
  var filterer = state.filterer;
  return new Promise(function (resolve, reject) {
    var doneAndReject = function doneAndReject(error) {
      state.done = true;
      reject(error);
    };
    var ifAbruptCloseAsyncIterator = function ifAbruptCloseAsyncIterator(error) {
      closeAsyncIteration(iterator, doneAndReject, error, doneAndReject);
    };
    var loop = function loop() {
      try {
        Promise.resolve(anObject(call(state.next, iterator))).then(function (step) {
          try {
            if (anObject(step).done) {
              state.done = true;
              resolve({
                done: true,
                value: undefined
              });
            } else {
              var value = step.value;
              try {
                Promise.resolve(filterer(value)).then(function (selected) {
                  selected ? resolve({
                    done: false,
                    value: value
                  }) : loop();
                }, ifAbruptCloseAsyncIterator);
              } catch (error3) {
                ifAbruptCloseAsyncIterator(error3);
              }
            }
          } catch (error2) {
            doneAndReject(error2);
          }
        }, doneAndReject);
      } catch (error) {
        doneAndReject(error);
      }
    };
    loop();
  });
});
$({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  filter: function filter(filterer) {
    return new AsyncIteratorProxy(getIteratorDirect(this), {
      filterer: aCallable(filterer)
    });
  }
});